import { EntityId } from "@reduxjs/toolkit";

import { Alert, Grid, LinearProgress } from "@mui/material";

import { useAppSelector } from "app/hooks";
import { playbackSessionSelectors } from "./store/selectors.session";
import { playbackSelectionSelectors } from "./store/selectors.selection";
import { selectShowSidebar } from "features/core/store/selectors";

import { PlaybackDevice } from "./PlaybackDevice";

export interface PlaybackDeviceGridProps {
    sessionId: string;
    siteId: EntityId;
    drawerWidth: number;
}

export function PlaybackDeviceGrid(props: PlaybackDeviceGridProps) {
    const showSidebar = useAppSelector(selectShowSidebar);

    const selectedDeviceIds = useAppSelector(
        playbackSelectionSelectors.selectDeviceIds,
    );

    const readyForPlaybackStatistics = useAppSelector(
        playbackSessionSelectors.selectReadyForPlaybackStatistics,
    );

    return (
        <>
            {!readyForPlaybackStatistics.ready && (
                <Alert
                    elevation={5}
                    severity="info"
                    sx={(theme) => ({
                        position: "fixed",
                        zIndex: theme.zIndex.speedDial - 1,
                        top: theme.spacing(12),
                        marginLeft: theme.spacing(2),
                        marginRight: theme.spacing(2),
                        width: `calc(100% - ${showSidebar ? props.drawerWidth : 0}px - ${theme.spacing(10)})`,
                        transition: theme.transitions.create("width", {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.shortest,
                        }),
                        ".MuiAlert-message": {
                            width: "100%",
                        },
                    })}
                >
                    Buffering recordings...
                    <LinearProgress
                        sx={{ marginTop: 1 }}
                        variant="determinate"
                        value={
                            readyForPlaybackStatistics.percentageReadyForPlayback
                        }
                    />
                </Alert>
            )}
            <Grid
                container
                spacing={2}
            >
                {selectedDeviceIds.map((deviceId) => (
                    <Grid
                        size={{
                            xs: 6,
                        }}
                        key={deviceId}
                    >
                        <PlaybackDevice
                            key={deviceId}
                            sessionId={props.sessionId}
                            siteId={props.siteId}
                            deviceId={deviceId}
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
}
